import { ISubDealerLocatorModel } from "@app/account/account.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const dealerLocatorAdapter: EntityAdapter<ISubDealerLocatorModel> = createEntityAdapter<ISubDealerLocatorModel>({
	selectId: locator => locator.subDealerId
});